import { FormlyFieldConfig } from '@ngx-formly/core/lib/models/fieldconfig';
import { FieldType, LuFormlyBuilder } from 'lu-formly';
import { LuButtonFormly } from '../lu-button-formly.models';

export class LuButtonFormlyBuilder extends LuFormlyBuilder {
	protected type: FieldType = 'lu-button-formly' as FieldType;

	private buttonOptions: Partial<LuButtonFormly> = {};

	public setButtonOptions(options: Partial<LuButtonFormly>): this {
		this.buttonOptions = options;
		return this;
	}

	public build(): FormlyFieldConfig {
		// NOTE: button key is not added to the form/model
		// hardcoded here to avoid need for adding one in ctor when creating btn object
		this.key = 'temp-key';

		const field = super.build();

		if (this.buttonOptions) {
			field.templateOptions.buttonOptions = this.buttonOptions;
		}

		field.templateOptions.buttonOptions.disabled = !!this.disabled || !!this.readonly;

		return field;
	}
}
